module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Gc-Ha-Ib-Jb.525966fd.png";